import { Entity, type EntityProps } from '../../../core/context/entity';

export class AssetRelationType extends Entity {
    constructor({ id, name }: EntityProps) {
        super({ id, name });
    }
}
